<template>
<div>
  <h1>Video Search</h1>
  <div class="ibox">
    <div class="row">
      <div class="col-lg-3">
        <div class="col-lg-3">7d views:</div>
        <div class="col-lg-9">
          <input type="number" name="7dFrom" min="0" class="col-lg-4" placeholder="From" v-model="query['7dViewsFrom']">
          <input type="number" name="7dTo" min="0" class="col-lg-4" placeholder="To" v-model="query['7dViewsTo']">
        </div>
      </div>
      <div class="col-lg-3">
        <div class="col-lg-3">30d views:</div>
        <div class="col-lg-9">
          <input type="number" name="30dFrom" min="0" class="col-lg-4" placeholder="From" v-model="query['30dViewsFrom']">
          <input type="number" name="30dTo" min="0" class="col-lg-4" placeholder="To" v-model="query['30dViewsTo']">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="col-lg-3">Tag count:</div>
        <div class="col-lg-9">
          <input type="number" name="tagCountFrom" min="0" class="col-lg-4" placeholder="From" v-model="query['tagCountFrom']">
          <input type="number" name="tagCountTo" min="0" class="col-lg-4" placeholder="To" v-model="query['tagCountTo']">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="col-lg-3">Order by:</div>
        <div class="col-lg-9">
          <select name="orderBy" class="col-lg-4" v-model="query['order']">
            <option value="meta:num:views_7" selected="selected">7d Views</option>
            <option value="meta:num:views_30">30d Views</option>
          </select>
          <select name="orderDir" class="col-lg-4" v-model="query['orderDir']">
            <option value="ASC">Ascending</option>
            <option value="DESC" selected="selected">Descending</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <button class="btn btn-primary btn-sm" @click="searchVideos">Search</button>
      </div>
    </div>
    <div class="ibox-title m-t-md">
      <div v-if="results.length">
        <h4>Results ({{ this.resultCount }})</h4>
        <button class="pull-right btn btn-success btn-sm" @click="deleteVideos">Delete</button>
        <table class="table table-striped table-bordered table-hover dataTables-example">
          <thead>
          <tr>
            <th class="col-lg-1">Category</th>
            <th>Tag Count</th>
            <th class="col-lg-1">Tags</th>
            <th class="col-lg-4">Title</th>
            <th class="col-lg-1">7d V</th>
            <th class="col-lg-1">30d V</th>
            <th class="col-lg-1">KWs</th>
            <th>
              <input type="checkbox" name="" v-if="resultCount" @click="toggleAllVideos">
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="vid in results" :key="vid.ID" :data-id="vid.ID">
            <td>{{ vid.category.name }}</td>
            <td class="center">{{ vid.tags.length }}</td>
            <td>{{ vid.tags.map(t => t.name).join(',') }}</td>
            <td>
              {{ vid.post_title }}
              <a :href="vid.guid" target="_blank"><i class="fa fa-external-link"></i></a>
            </td>
            <td class="center">{{ getVal(vid.meta.views_7) }}</td>
            <td class="center">{{ getVal(vid.meta.views_30)  }}</td>
            <td></td>
            <td>
              <input type="checkbox" class="vidCheck" name="" id="" @change="selectVid(vid.ID)" :data-id="vid.ID">
              <i class="fa fa-remove"></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <span v-if="resultCount !== null">No videos found...</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'VideoSearch',
  data () {
    return {
      results: [],
      resultCount: null,
      query: {},
      selectedVids: []
    }
  },
  props: ['site'],
  methods: {
    searchVideos () {
      this.results = []
      this.resultCount = null
      // this.query.order = 'meta:num:views_7'
      // this.query.orderDir = 'DESC'
      this.query.limit = -1
      let qp = Object.keys(this.query).map(key => key + '=' + this.query[key]).join('&')
      let q = '/am/plugin/site/' + this.site.url + '/videos?' + qp
      axios.get(q)
        .then(r => {
          this.results = r.data.data
          this.resultCount = r.data.meta.count
        })
        .catch(e => {
          this.$toastr.error('Awwwww shiiiyat. Try to narrow it down a bit.', 'Bad stuff hombre')
        })
    },
    selectVid (id) {
      if (this.selectedVids.indexOf(id) !== -1) {
        this.selectedVids = this.selectedVids.filter(e => e !== id)
      } else {
        this.selectedVids.push(id)
      }
    },
    removeSelectedVideos () {
      if (confirm('Delete ' + this.selectedVids.length + ' videos?')) {
        this.selectedVids.forEach(v => {
          this.deleteVideo(v, null, null, true)
        })
      }
    },
    toggleAllVideos (e) {
      $('.vidCheck').prop('checked', e.target.checked)
      console.log(this.site)
    },
    deleteVideos () {
      if (confirm('Delete ' + $('.vidCheck:checked').length + ' videos?')) {
        let site = this.site
        $('.vidCheck:checked').each(function (e) {
          let id = $($('.vidCheck:checked')[e]).data('id')
          axios.delete('/am/plugin/site/' + site.url + '/video/' + id)
            .then(r => {
              $('tr[data-id=' + id + ']').hide()
            })
            .catch()
        })
      }
    },
    getVal (val) {
      if (val && val[0]) {
        return val[0]
      } else {
        return '/'
      }
    }
  }
}
</script>

<style scoped>
  .center {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Site/VideoSearch.vue